import { useCallback } from 'react';

import { Alert, Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import './ErrorFallback.scss';

interface Error {
  message?: string;
}

interface Props {
  error?: Error;
  actionHandler?: () => void;
  errorText?: string;
  actionText?: string;
}

const ErrorFallback = ({ error, actionHandler, errorText, actionText }: Props) => {
  const { t } = useTranslation();
  const resetBoundary = useCallback(() => {
    window.location.reload();
  }, []);
  return (
    <div className="errorcss">
      <Alert
        description={
          // eslint-disable-next-line sonarjs/deprecation
          <Tooltip destroyTooltipOnHide placement="left" title={error?.message ?? ''}>
            {errorText ?? t('wrong')}
          </Tooltip>
        }
        type="error"
        action={
          <Button onClick={actionHandler ?? resetBoundary} type="primary" key="refresh">
            {actionText ?? t('refresh')}
          </Button>
        }
      />
    </div>
  );
};

export default ErrorFallback;
